export default "__VITE_ASSET__Dqflm3Dv__"